'use client';

import { ErrorCharacter } from '@/components/illustrations/ErrorCharacter';
import '../styles/globals.css';

import * as Sentry from '@sentry/nextjs';
import { ErrorPage } from '@pickleballinc/features/src/error-pages/error-page';
import { Button } from '@pickleballinc/ui/components/ui/button';
import Link from 'next/link';
import { useEffect } from 'react';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
	useEffect(() => {
		Sentry.captureException(error);
	}, [error]);

	return (
		<html>
			<body>
				<div className="flex size-full min-h-screen flex-1 flex-col items-center justify-center bg-gray-100 text-gray-700 antialiased">
					<main className="w-full bg-gray-100 py-4 sm:py-6">
						<ErrorPage
							customErrorCharacter={<ErrorCharacter className="max-w-[200px] md:max-w-[400px] lg:max-w-[500px] h-auto" />}
							title="Page out of bounds."
							description="We couldn’t find the page you were looking for."
							titleClassName="mt-10 text-xl font-semibold text-gray-900 sm:text-3xl"
							descriptionClassName="font-medium text-gray-700"
						>
							<Link href="/" prefetch={false}>
								<Button variant="default" className="w-full bg-orange-500 text-white hover:bg-orange-700 md:w-32">
									Back to home
								</Button>
							</Link>
						</ErrorPage>
					</main>
				</div>
			</body>
		</html>
	);
}
